import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import useStyles from './styles';
import FilterForm from './filter_form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from '../../configuration';

interface IProps {
  vatNumber: string | null;
  notificationType: string | null;
  notificationDateFrom: Date | null;
  notificationDateTo: Date | null;
}

const Filter = (props: IProps) => {
  const classes = useStyles();

  return (
    <div
      className={clsx({
        [classes.cardLayout]: true,
        [classes.filter]: true,
      })}
    >
      <div className={classes.filter_header}>
        <SearchIcon style={{ marginRight: '1rem' }} />
        <span style={{ fontSize: '1.2rem' }}>
          <TranslatedText textMap={Translations.search} />
        </span>
      </div>
      <FilterForm
        vatNumber={props.vatNumber}
        notificationType={props.notificationType}
        notificationDateFrom={props.notificationDateFrom}
        notificationDateTo={props.notificationDateTo}
      />
    </div>
  );
};

export default Filter;
